<template>
  <div class="h-100">
    <div
      class="card card-frame h-100 mr-1 ml-1 cursor-pointer"
      @click="clickHandler(item)"
    >
      <div class="card-body">
        <div v-show="loading">
          <figure class="w-100 max-w-8rem mr-4">
            <div class="avatar avatar-md mt-1 mr-2 border">
              <SkeletonUI type="img" class="avatar-img shadow" />
            </div>
          </figure>
          <div class="mb-0">
            <SkeletonUI type="h4" :lines="2" class="skeleton-name" />
          </div>
        </div>
        <div v-show="!loading">
          <figure class="w-100 max-w-8rem mr-4 mb-2">
            <div class="avatar avatar-md mt-1 mr-2 border">
              <img
                v-img
                class="avatar-img shadow"
                :src="item.profile_picture_url ? item.profile_picture_url : require('@/assets/img/provider-default/default-icon.jpg')"
                width="48"
                height="48"
              >
            </div>
          </figure>
          <h4 class="mb-0 text-truncate-3">{{ `${item.display_name}` }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonUI from './skeleton-ui.vue'

export default {
  name: 'ProviderCard',
  components: {
    SkeletonUI
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          id: '',
          profile_picture_url: '/assets/img/provider-default/default-icon.jpg',
          display_name: 'API EcoBooster'
        }
      }
    },
    clickHandler: {
      type: Function,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}
.avatar-img {
  width: 100%;
  height: 100%;
}
.card {
  min-height: 200px;
}
</style>
